import { render, staticRenderFns } from "./SelectIndicadores.vue?vue&type=template&id=2a9d895b"
import script from "./SelectIndicadores.vue?vue&type=script&lang=js"
export * from "./SelectIndicadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports